
let grab_headers = {
  'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmb28iOiJjbXMtbHVwaXRhIn0.r0RrbCPpevVS9viZlXRmw-iNDFQycOot4OrXwgPlFkg',
  'Content-Type':  'application/json',
}

let lup_headers = {
  'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2x1cGl0YS5hdXRoMC5jb20vIiwic3ViIjoiZ29vZ2xlLW9hdXRoMnwxMDA1MjU2ODQ4MjkxNDQyMDM2MTQiLCJhdWQiOiJjZnN5TFl2Z0hfTTlsUW1QN3ZuQnFRYXNaa01Fd1FmSCIsImV4cCI6MTQ5ODYxODQxMSwiaWF0IjoxNDk4NTc1MjExfQ.apHmgCHfsudRkXKNBlVMa_1TZh7SZLTjgQ_nbGCYqks',
  'Content-Type':  'application/json',
  'Country': 'mx'
}

const services = {

  async createUser(user) {
    let newUser = {
     email: user.email,
     first_name: user.first_name,
     last_name: user.last_name,
     phone: user.phone,
     gender: 'm',
     replacement_criteria_id: "replace",
     password: "rappirappi"
    }
   const response = await fetch("https://v2.mxgrability.rappi.com/api/register",{ headers: grab_headers , method: 'POST', body: JSON.stringify(newUser) });
   return await response.json();
 },

  async addAddress(address) {
    address = JSON.stringify(address);
    const response = await fetch("https://lup-api.rappi.com/api/landing/addresses/" ,{ headers: lup_headers,  method: "POST", body: address });
    return await response.json();
  },

   async createOrder(order) {
     order = JSON.stringify(order);
     const response = await fetch('https://lup-api.rappi.com/api/landing/orders/' , { headers: lup_headers , method: 'POST', body: order });
     return await response.json();
   },

   async getUserToken() {
     let u = JSON.parse(localStorage.getItem('user'))
     let user = {
       user: {
       email: u.email,
       pass:"rappirappi",
       id: u.id
     }
    }
    const response = await fetch('https://lup-api.rappi.com/api/landing/users/token/' ,{ headers: lup_headers ,method: 'POST',  body: JSON.stringify(user) });
    return await response.json();
  },

  async getAddresses(id) {
    const response = await fetch('https://lup-api.rappi.com/api/landing/addresses/' + id , { headers: lup_headers });
    return await response.json();
  },

  async getShippingCharges(lat,lng) {
     const response = await fetch(`https://lup-api.rappi.com/api/landing/shipping-charges/?lat=${lat}&lng=${lng}` , { headers: lup_headers});
     return await response.json();
  }

}

export default services;



// WEBPACK FOOTER //
// ./src/services.js